import { isSocialLoginUrl } from '../../../app/src/features/authentication/constants/SocialAuth';
import useAuth from '../../../app/src/features/authentication/hooks/useAuth';

interface UploadFunctionParams {
  distributionId?: string;
  brokerId?: string;
  filename: string;
}

interface UploadObject {
  location: string;
  link: string;
  document_id: string;
  public_bucket_link: string;
  public_url: string;
}

export type UploadFunctionRes = Promise<[UploadObject, number]>;

type UploadFileFunction = (file: File) => Promise<UploadObject>;

const useUploadFile = (
  uploadFunction: (params: UploadFunctionParams) => UploadFunctionRes,
): UploadFileFunction => {
  const { user, campaign } = useAuth();

  const uploadFile: UploadFileFunction = async (file) => {
    let uploadParams = {
      filename: file.name,
    } as UploadFunctionParams;
    if (isSocialLoginUrl) {
      uploadParams = {
        ...uploadParams,
        distributionId: campaign?.distribution_id,
        brokerId: campaign?.assigned_to || campaign?.created_by,
      };
    } else if (user) {
      uploadParams = {
        ...uploadParams,
        distributionId: user.distribution_id,
        brokerId: user.id,
      };
    }
    const [urlRes, urlStatus] = await uploadFunction(uploadParams);

    if (urlStatus <= 201) {
      await fetch(urlRes.link, {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file,
      });

      return {
        document_id: urlRes.document_id,
        location: urlRes.location,
        link: urlRes.link,
        public_bucket_link: urlRes.public_bucket_link,
        public_url: urlRes.public_url,
      };
    }

    throw urlRes;
  };

  return uploadFile;
};

export default useUploadFile;
